module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// /app/~/stream-browserify/~/readable-stream/transform.js
// module id = 96
// module chunks = 0